<script>
	import LineItemAttributes from './LineItemAttributes.svelte'
	import { format_money_$ } from 'shared/format_currency'
	import { storefront_uber_fetch } from 'shared/ops_api'
	import HolsterImage from 'shared/component/HolsterImage.svelte'
	import { capitalize } from 'shared/util'

	export let item

	const width = 180
	const product_image = `${ item.product.image_src }&w=${ width }&dpr=${ window.devicePixelRatio }`

	let image_src_promise
	if (item.holster_availability_ref && item.color_ref) {
		const belt_width = item.attributes.find(({ key }) => key === `Belt Width`)?.value
		const clip_material = item.attributes.find(({ key }) => key === `Clip Material`)?.value

		image_src_promise = storefront_uber_fetch(`holster_image?${ new URLSearchParams({
			holster_availability_ref: item.holster_availability_ref,
			color_ref: item.color_ref,
			threaded: item.attributes.some(({ key, value }) => key === `Threaded Barrel` && value === `Threaded`),
			...(belt_width && { belt_width }),
			...(clip_material && { clip_material }),
		}) }`)
	}
	if (item.holster_accessory_variation_ref && item.color_ref) {
		image_src_promise = storefront_uber_fetch(`holster_accessory_image?${ new URLSearchParams({
			holster_accessory_variation_ref: item.holster_accessory_variation_ref,
			color_ref: item.color_ref,
		}) }`)
	}

	const discount_text = item.sales_kit_ref
		? ``
		: Number(item.product.discount_fixed)
			? `${ format_money_$(item.product.discount_fixed) } off`
			: Number(item.product.discount_pct)
				? item.hide_pct_discount
					? `Sale`
					: `${ item.product.discount_pct * 100 }% off`
				: ``
</script>

<div class="product-image">
	<a href="{ item.product.permalink }" tabindex="-1" title="{ item.product.name }">
		{#if image_src_promise}
			{#await image_src_promise then { image_url, belt_loop_image_url, image_position_algorithm }}
				{#if image_url}
					<HolsterImage
						{image_url}
						{belt_loop_image_url}
						is_accessory={!!item.holster_accessory_variation_ref}
						image_alt={item.product.name}
						{image_position_algorithm}
						flip_x={item.preview_flip_x}
						is_attached_to_holster={item.is_attached_to_holster}
						{width}
					/>
				{:else}
					<img src="{ product_image }" alt="{ item.product.name }" />
				{/if}
			{:catch}
				<img src="{ product_image }" alt="{ item.product.name }" />
			{/await}
		{:else}
			<img src="{ product_image }" alt="{ item.product.name }" />
		{/if}
		{#if discount_text}
			<span class="discount">{discount_text}</span>
		{/if}
	</a>
</div>
<div class="text">
	<div class="block">
		<div class="meta">
			<a class="title" href="{ item.product.permalink }" title="{ item.product.name }">{ item.product.name } </a>

			{#if item.product.type !== `donation` && item.product.type !== `gift_card`}<div class="lead_time">{ item.product.lead_time }</div>{/if}

			{#if item.product.itar}<div class="itar_container"><div class="itar_icon">ITAR<div class="itar_tooltip">This product is regulated by ITAR.  It can only be shipped in the USA.</div></div></div>{/if}
		</div>
	</div>

	<LineItemAttributes attributes={item.attributes} />

	{#if item.product.type === `trex_gift_card` && item.gift_card_personalization}
		<LineItemAttributes attributes={
			Object.entries(item.gift_card_personalization)
				.map(([ key, value ]) => ({ key: capitalize(key).replaceAll(`_`, ` `), value }))
		} />
	{/if}
</div>
<slot></slot>

<style>
	.product-image {
		position: relative;
		width: 180px;
		flex: 0 0 auto;
	}

	.product-image img {
		display: block;
	}

	.product-image .discount {
		padding: 10px;
		background: var(--flaregun-red);
		position: absolute;
		top: 0;
		left: 0;
		letter-spacing: 3px;
		color: #fff;
		text-transform: uppercase;
		line-height: 1;
	}

	@media (max-width: 600px) {
		.product-image .discount {
			font-size: 80%;
		}
		.product-image {
			width: 110px;
		}
	}

	.text {
		padding: 10px 10px 0 20px;
		width: 100%;
	}

	@media (max-width: 600px) {
		.text {
			padding: 0 0 0 10px;
		}
	}

	.block {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		width: 100%;
	}

	.meta {
		max-width: 550px;
		display: inline-block;
		margin-bottom: 5px;
		margin-top: -4px;
	}

	.title {
		font-size: 120%;
		line-height: 1;
		margin: 3px 8px 5px 0;
	}

	@media (max-width: 600px) {
		.title {
			font-size: 120%;
		}
	}

	.lead_time {
		display: inline-block;
		font-size: 14px;
		color: #bbb;
		margin: 5px 10px 5px 0;
	}

	@media (max-width: 600px) {
		.lead_time {
			font-size: 12px;
			margin: 2px 5px 2px 0;
		}
	}

	.itar_container {
		display: inline-block;
	}

	.itar_icon {
		float: none;
		margin: 0;
		font-size: 14px;
		padding-left: 10px;
	}

	.itar_icon:after {
		margin-top: -2px;
	}

	@media (max-width: 600px) {
		.itar_icon {
			font-size: 12px;
			padding: 6px;
			padding-right: 26px;
		}

		.itar_icon:after {
			width: 14px;
			line-height: 14px;
			right: 6px;
			margin-top: -1px;
		}
	}
</style>
